// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyChIaKEZouqq6RWGsLf9ZM9MfR0tSMS3tE",
  authDomain: "hamajima-cho-textbook-license.firebaseapp.com",
  projectId: "hamajima-cho-textbook-license",
  storageBucket: "hamajima-cho-textbook-license.firebasestorage.app",
  messagingSenderId: "473824408705",
  appId: "1:473824408705:web:af8960e28abdec68688980",
  measurementId: "G-L3M4Y2CC9K"
};